export default "__VITE_ASSET__BwF7Zmgr__"